import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { faLink, faLinkSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { I18NextNS } from 'src/models/Language.model';

import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';

const CameraConnectivity = () => {
  const { error } = useGetCurrentCaptureProcess();
  const { cameraData } = useRemoteBoundStore();

  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip>{t('header.cameraIp')}</Tooltip>}
    >
      <Button
        variant={error ? 'danger' : 'primary'}
        data-track="camera.status.show"
        data-observe
        data-test="camera-connectivity-status"
      >
        <FontAwesomeIcon icon={error ? faLinkSlash : faLink} className="me-2" />
        {cameraData?.ip}
      </Button>
    </OverlayTrigger>
  );
};

export default CameraConnectivity;
